import connect from './connect';
import TextWizard from './TextWizard';

export default connect(TextWizard);
